"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIC = void 0;
var country_1 = require("./country");
var bicUtil = require("./bicUtil");
var BIC = (function () {
    function BIC(bic) {
        bicUtil.validate(bic);
        this.value = bic;
    }
    BIC.prototype.getBankCode = function () {
        return bicUtil.getBankCode(this.value);
    };
    BIC.prototype.getCountryCode = function () {
        return country_1.countryByCode(bicUtil.getCountryCode(this.value));
    };
    BIC.prototype.getLocationCode = function () {
        return bicUtil.getLocationCode(this.value);
    };
    BIC.prototype.getBranchCode = function () {
        if (bicUtil.hasBranchCode(this.value)) {
            return bicUtil.getBranchCode(this.value);
        }
        return null;
    };
    BIC.prototype.toString = function () {
        return this.value;
    };
    BIC.isValid = function (bic) {
        try {
            bicUtil.validate(bic);
        }
        catch (_a) {
            return false;
        }
        return true;
    };
    return BIC;
}());
exports.BIC = BIC;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmljLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2JpYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxQ0FBdUQ7QUFDdkQsbUNBQXFDO0FBT3JDO0lBV0UsYUFBWSxHQUFXO1FBQ3JCLE9BQU8sQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7UUFFdEIsSUFBSSxDQUFDLEtBQUssR0FBRyxHQUFHLENBQUM7SUFDbkIsQ0FBQztJQU9ELHlCQUFXLEdBQVg7UUFDRSxPQUFPLE9BQU8sQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFPRCw0QkFBYyxHQUFkO1FBQ0UsT0FBTyx1QkFBYSxDQUFDLE9BQU8sQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7SUFDM0QsQ0FBQztJQU9ELDZCQUFlLEdBQWY7UUFDRSxPQUFPLE9BQU8sQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFPRCwyQkFBYSxHQUFiO1FBQ0UsSUFBSSxPQUFPLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUNyQyxPQUFPLE9BQU8sQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQzFDO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBS0Qsc0JBQVEsR0FBUjtRQUNFLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUNwQixDQUFDO0lBT00sV0FBTyxHQUFkLFVBQWUsR0FBVztRQUN4QixJQUFJO1lBQ0YsT0FBTyxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUN2QjtRQUFDLFdBQU07WUFDTixPQUFPLEtBQUssQ0FBQztTQUNkO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBQ0gsVUFBQztBQUFELENBQUMsQUE1RUQsSUE0RUM7QUE1RVksa0JBQUcifQ==